import React from 'react'
import PropTypes from 'prop-types'
import { Box, Stepper, Step, StepLabel } from '@mui/material'

import './style.scss'

export const FormProgress = ({ steps }) => {
  // const { t } = useTranslation()
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={1} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
FormProgress.propTypes = {
  steps: PropTypes.array.isRequired
}
